export const APP_TITLE = 'TherAppy Inc';
export const STORAGE_KEY = 'therappy';
